import { buildProps, definePropType } from '@ll-plus/utils'

import { AutoCompleteProps as AntAutoCompleteProps } from 'ant-design-vue'
import type { ExtractPropTypes } from 'vue'
import type AutoComplete from './auto-complete.vue'

export const autoCompleteProps = buildProps({
  value: {
    type: String,
    default: '',
  },
  options: {
    type: definePropType<AntAutoCompleteProps['options']>(Array),
    default: () => [],
  },
  placeholder: {
    type: String,
    default: '',
  },
  allowClear: {
    type: Boolean,
    default: true,
  },
  bordered: {
    type: Boolean,
    default: true,
  },
  // 是否区分大小写
  caseSensitive: {
    type: Boolean,
    default: false,
  },
  isGray: {
    type: Boolean,
    default: false,
  },
  filterOption: {
    type: definePropType<
      boolean | ((input: string, option: { value: string }) => boolean)
    >([Boolean, Function]),
    default: true,
  },
  // 是否多行输入
  isMultiLine: {
    type: Boolean,
    default: false,
  },
  // 下拉展开时机
  expandOpportunity: {
    type: String,
    values: ['focus', 'change', 'character'],
    default: 'focus',
  },
  // 触发字符
  triggerCharacter: {
    type: String,
    default: '',
  },
  // 追加模式 true选择后追加 false选择后覆盖
  appendMode: {
    type: Boolean,
    default: false,
  },
  // 追加符号
  appendCharacter: {
    type: String,
    default: '',
  },
  // 无匹配项时忽略选中
  ignoreSelection: {
    type: Boolean,
    default: true,
  },
} as const)

// props
export type AutoCompleteProps = ExtractPropTypes<typeof autoCompleteProps>

// instance
export type AutoCompleteInstance = InstanceType<typeof AutoComplete>
